/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.OrderCompanyModel>>;
export function request(
  body: defs.basics.OrderCompanyRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/orderCompany/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
